/**
 * 图片间隔
 */
export const horizontalOffset = 20;

/**
 * 最小初始响应距离
 */
export const minStartTouchOffset = 10;

/**
 * 最小切换图片距离
 */
export const minSwitchImageOffset = 40;

/**
 * 最大缩放度（若图片足够大，则会超出该值）
 */
export const maxScale = 6;
